import messages from '@/content/data/validation-messages'
import render from '@/filters/render'

/**
 * Build a dynamic error message.
 *
 * @param {object} v A vuelidate instance, eg this.$v.<instance>
 * @param {string} field The name of the field to display
 */
const errorMessage = (v, field) => {
  if (!v.$error) return ''
  let message = null

  if (v.$params.required && !v.required) {
    message = messages.required
  } else if (v.$params.minValue && !v.minValue) {
    message = messages.min_value
  } else if (v.$params.maxValue && !v.maxValue) {
    message = messages.max_value
  } else if (v.$params.maxLength && !v.maxLength) {
    message = messages.max_length
  } else if (v.$params.minLength && !v.minLength) {
    message = messages.min_length
  } else if (v.$params.maxWords && !v.maxWords) {
    message = messages.max_words
  } else if (v.$params.accepted_pattern && !v.accepted_pattern) {
    message = messages.accepted_pattern
  } else if (v.$params.email && !v.email) {
    message = messages.email
  } else if (v.$params.url && !v.url) {
    message = messages.url
  } else if (v.$params.accepted_phone_pattern && !v.accepted_phone_pattern) {
    message = messages.accepted_phone_pattern
  } else if (v.$params.accepted_names_pattern && !v.accepted_names_pattern) {
    message = messages.accepted_names_pattern
  } else if (!v.server_error) {
    message = v.server_error_message
  }

  // If we have an error message, render the variables and return it
  return message ? render(message, { v, field }) : ''
}

export { errorMessage }
